export default "__VITE_ASSET__DBQ5MmoB__"